//import moment from 'moment';

//export const formatDate = (dateString) => {
//  if (!dateString) return '';
//  return moment.utc(dateString).local().format('MM/DD/YYYY');
//};

//export const formatDateTime = (dateTimeString) => {
//  if (!dateTimeString) return '';
//  return moment.utc(dateTimeString).local().format('MM/DD/YYYY hh:mm:ss A');
//};

//export const formatTime = (timeString) => {
//  if (!timeString) return '';
//  return moment.utc(timeString).local().format('hh:mm A');
//};

import moment from 'moment';

export const formatDate = (dateString) => {
  // Parse the date using moment
  const parsedDate = moment(dateString);

  // Format the parsed date in the desired format
  const formattedDate = parsedDate.format('MM/DD/YYYY');

  return formattedDate;
};
export const formatDateInWords = (dateString) => {
  // Parse the date using moment
  const parsedDate = moment(dateString);

  // Format the parsed date in the desired format
  const formattedDate = parsedDate.format('DD MMM, YYYY');

  return formattedDate;
};

export const formatDateTime = (dateTimeString) => {
  // Parse the date and time using moment in UTC mode
  const parsedDateTime = moment.utc(dateTimeString).local();

  // Format the parsed date and time in the desired format
  const formattedDateTime = parsedDateTime.format('MM/DD/YYYY hh:mm:ss A');
  return formattedDateTime;
};
//export const formatTime = (TimeString) => {
//  const parsedTime = moment.utc(TimeString);
//  const formattedTime = parsedTime.format('HH:mm:ss');
//  return formattedTime;
//};
export const formatTime = (timeString) => {
  if (!timeString) return '';

  // Parse in local time (not UTC)
  const parsedTime = moment(timeString); // local time

  // Format as HH:mm:ss or hh:mm A for AM/PM
  const formattedTime = parsedTime.format('HH:mm:ss'); // 24-hour format
  // const formattedTime = parsedTime.format('hh:mm A'); // 12-hour with AM/PM

  return formattedTime;
};

export const formatWaveTime = (timeString) => {
  if (!timeString) return '';

  return moment(formatTime(timeString), 'HH:mm:ss').format('hh:mm A');
};
export function isDateBeforeToday(dateString) {
  // Define months for conversion
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  // Split the input date string into day, month, and year
  const [, monthStr, day] = dateString.split(' ');

  // Map the month abbreviation to its numeric representation
  const month = months.indexOf(monthStr);

  // Get the current date
  const currentDate = new Date();

  // Set the time part of the current date to midnight
  currentDate.setHours(0, 0, 0, 0);

  // Create a new date object with the input date's year, month, and day
  const inputDate = new Date(currentDate.getFullYear(), month, day);

  // Compare the input date with the current date
  return inputDate < currentDate;
}
export function getDateRange(date, navigateDateMode) {
  if (navigateDateMode == 0) {
    // Week mode
    const startOfWeek = moment(date).startOf('week');
    const endOfWeek = moment(date).endOf('week');
    return {
      minDate: startOfWeek.toDate(),
      maxDate: endOfWeek.toDate(),
      minDateString: startOfWeek.format('YYYY-MM-DD'),
      maxDateString: endOfWeek.format('YYYY-MM-DD'),
      minTimestamp: startOfWeek.valueOf(),
      maxTimestamp: endOfWeek.valueOf(),
      mode: 'week',
      label: `${startOfWeek.format('MMM D')} - ${endOfWeek.format('MMM D, YYYY')}`,
    };
  }

  // Day mode
  const selectedDay = moment(date);
  return {
    minDate: selectedDay.toDate(),
    maxDate: selectedDay.toDate(),
    minDateString: selectedDay.format('YYYY-MM-DD'),
    maxDateString: selectedDay.format('YYYY-MM-DD'),
    minTimestamp: selectedDay.valueOf(),
    maxTimestamp: selectedDay.valueOf(),
    mode: 'day',
    label: selectedDay.format('dddd, MMMM D, YYYY'),
  };
}
